import { Component, Vue } from 'vue-property-decorator';
import ArticleAuthor from '@/components/ArticleAuthor/ArticleAuthor.vue';
import { getComponentProps } from '@/utils/vueUtils';
import { ArticleAuthorModuleViewModel } from './ArticleAuthorModule.types';
import { getResizeImage } from '@/utils/commonUtils';

const ArticleAuthorModuleProps = Vue.extend({
  props: getComponentProps<ArticleAuthorModuleViewModel>({
    Id: 'id',
    IsCardLandscape: true,
    ArticleAuthors: [
      {
        Image: { Url: getResizeImage('thumbnail-sven.jpg'), Alt: 'Sven' },
        Name: 'Peter Hillary',
        Text:
          'The son of Sir Edmund Hillary, Peter is the first second-generation to climb Mt. Everest. He has climbed the Seven Summits, been on over 40 mountaineering expeditions around the world, and in 1999, he established one of the five Ross Sea routes to the South Pole via the Shackleton Glacier.',
        Link: '#',
        Title: 'Mountaineer',
        ArticleRole: 'Article by',
      },
      {
        Image: { Url: getResizeImage('thumbnail-sven.jpg'), Alt: 'Sven' },
        Name: 'June Glebb',
        Text:
          'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Necessitatibus ex eos officiis mollitia fugiat qui nulla aliquid. Id vel consequatur quae ex quod minus placeat aliquid, laudantium tempore aspernatur qui!',
        Link: '#',
        Title: 'Videographer',
        ArticleRole: 'Videography by',
      },
      {
        Image: { Url: getResizeImage('captain-kruess.jpg'), Alt: 'Kreuss' },
        Name: 'James McCloyd',
        Text:
          'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Necessitatibus ex eos officiis mollitia fugiat qui nulla aliquid. Id vel consequatur quae ex quod minus placeat aliquid, laudantium tempore aspernatur qui!',
        Link: '#',
        Title: 'Team Leader',
        ArticleRole: 'Expedition led by',
      },
    ],
  }),
});

@Component({
  components: {
    ArticleAuthor,
  },
})
export default class ArticleAuthorModule extends ArticleAuthorModuleProps {}
